import { useMemo } from 'react';
import { layoutDaysOfMonth } from 'utils/helpers';
import { calendarDay, zonedDateTime, zonedMoment } from 'utils/timezone';
import CalendarCell from '../CalendarCell';

const CalendarBody = ({
  year,
  month,
  date,
  cellData = {},
  onChange,
  minimized,
}) => {
  const layoutDays = useMemo(
    () => layoutDaysOfMonth(year, month),
    [year, month]
  );

  const handleDaySelect = (day) => {
    const base = date ? zonedMoment(date) : zonedMoment(new Date());
    onChange(
      zonedDateTime({
        year,
        month: month - 1,
        day,
        hour: base.hour(),
        minute: base.minute(),
        second: base.second(),
      })
    );
  };

  return (
    <tbody>
      {Array.from({ length: 6 }).map(
        (_, row) =>
          (!row || layoutDays[row][0]) && (
            <tr key={row}>
              {layoutDays[row].map((day, idx) => (
                <CalendarCell
                  day={day}
                  key={idx}
                  data={
                    cellData?.[
                      day
                        ? calendarDay(year, month - 1, day).format('YYYY-MM-DD')
                        : undefined
                    ]
                  }
                  selected={
                    Boolean(day && date) &&
                    calendarDay(year, month - 1, day).isSame(
                      zonedMoment(date),
                      'day'
                    )
                  }
                  onSelect={handleDaySelect}
                  minimized={minimized}
                />
              ))}
            </tr>
          )
      )}
    </tbody>
  );
};

export default CalendarBody;
